import {
  subscribe,
  getFilteredCharacters,
  openModal,
  openModalForEdit,
  setSort,
  getState
} from '../state/store.js';

import { isInTimeJail, formatTimeJailDisplay } from '../utils/time-jail.js';

const tbody = document.getElementById('charactersTbody');
const cardsContainer = document.getElementById('charactersCards');
const sortButtons = document.querySelectorAll('.sort-btn');
const tableHead = document.querySelector('.table-panel thead');
const SORT_ASC = '▲'; // ▲
const SORT_DESC = '▼'; // ▼

const statusClass = (status) => {
  const key = String(status || '').toLowerCase();
  if (key.includes('alive')) return 'status-pill status-alive';
  if (key.includes('dead')) return 'status-pill status-dead';
  if (key.includes('missing')) return 'status-pill status-missing';
  if (key.includes('retired')) return 'status-pill status-retired';
  if (key.includes('captured')) return 'status-pill status-captured';
  if (key.includes('crippled')) return 'status-pill status-crippled';
  return 'status-pill';
};

const renderTimeJailValue = (value) => {
  if (!value) return '—';
  const displayValue = formatTimeJailDisplay(value);
  if (!isInTimeJail(value)) return displayValue;
  return `<span class="time-jail-badge">${displayValue}</span>`;
};

const renderRows = (rows) => {
  if (!rows.length) {
    tbody.innerHTML = `<tr><td colspan="7" class="placeholder">No characters match the filters.</td></tr>`;
    renderCards(rows);
    return;
  }
  tbody.innerHTML = rows
    .map(
      (c) => `<tr data-id="${c.id}" data-slug="${c.slug}">
      <td>
        <div class="name">${c.name || 'Unnamed'}</div>
        <div class="muted small">${c.race || ''}</div>
      </td>
      <td>${c.player || '—'}</td>
      <td><span class="${statusClass(c.status)}">${c.status || 'Unknown'}</span></td>
      <td>${c.class || '—'}</td>
      <td>${c.level || '—'}</td>
      <td>${c.current_location || '—'}</td>
      <td>${renderTimeJailValue(c.time_jail)}</td>
    </tr>`
    )
    .join('');
  renderCards(rows);
};

const renderCards = (rows) => {
  if (!cardsContainer) return;
  if (!rows.length) {
    cardsContainer.innerHTML = `<p class="placeholder">No characters match the filters.</p>`;
    return;
  }
  cardsContainer.innerHTML = rows
    .map(
      (c) => `<article class="character-card" data-id="${c.id}" data-slug="${c.slug}">
        <div class="card-main">
          <div class="card-name-row">
            <h4>${c.name || 'Unnamed'}</h4>
            <span class="${statusClass(c.status)}">${c.status || 'Unknown'}</span>
          </div>
          <div class="meta">${c.player || 'Unknown'} • ${c.class || 'Classless'} Lv ${c.level || '?'}</div>
          <div class="meta">Location: ${c.current_location || 'Unknown'}</div>
          <div class="meta">Time Jail: ${renderTimeJailValue(c.time_jail)}</div>
        </div>
      </article>`
    )
    .join('');
};

const updateSortIndicators = (sort) => {
  sortButtons.forEach((btn) => {
    if (btn.dataset.sort === sort.key) {
      btn.classList.add('active');
      btn.setAttribute('data-indicator', sort.direction === 'asc' ? SORT_ASC : SORT_DESC);
    } else {
      btn.classList.remove('active');
      btn.setAttribute('data-indicator', '');
    }
  });
};

export const initTable = () => {
  tbody.addEventListener('click', (event) => {
    const action = event.target?.dataset?.action;
    if (action === 'edit') {
      const row = event.target.closest('[data-id]');
      if (row) openModalForEdit(Number(row.dataset.id));
      event.stopPropagation();
      return;
    }
    const row = event.target.closest('tr[data-id]');
    if (!row) return;
    openModal(Number(row.dataset.id));
  });

  if (cardsContainer) {
    cardsContainer.addEventListener('click', (event) => {
      const card = event.target.closest('[data-id]');
      if (!card) return;
      openModal(Number(card.dataset.id));
    });
  }

  if (tableHead) {
    tableHead.addEventListener('click', (event) => {
      const btn = event.target.closest('.sort-btn');
      if (!btn) return;
      const key = btn.dataset.sort;
      setSort(key);
    });
  }

  subscribe(() => {
    const rows = getFilteredCharacters();
    const { sort } = getState();
    renderRows(rows);
    updateSortIndicators(sort);
  });

  renderRows(getFilteredCharacters());
  updateSortIndicators(getState().sort);
};
